export function getTimeStamp(){
  var now = new Date();
  var timestamp = now.toISOString();

  //  console.log(timestamp);

  return timestamp;
}